import { defineStore } from "pinia";

export const UIStore = defineStore("UIStore", {
  state: () => ({
    currentWidth: window.innerWidth,
    currentHeight: window.innerHeight,
    isMobile: false,
    showCreateAccountDialog: false,
    showMagicLinkSentDialog: false,
    magicLinkEmail: "",
    showCreatePasswordDialog: false,
    createPasswordEmail: "",
    showUnlockBenefitsDialog: false,
    showUnlockMoreBenefitsDialog: false,
  }),
  actions: {
    setUiSize(currentWidth: number, currentHeight: number, isMobile: boolean) {
      this.currentWidth = currentWidth;
      this.currentHeight = currentHeight;
      this.isMobile = isMobile;
    },
    setShowCreateAccountDialog(value: boolean) {
      this.showCreateAccountDialog = value;
    },
    setShowMagicLinkSentDialog(value: boolean) {
      this.showMagicLinkSentDialog = value;
    },
    setMagicLinkEmail(value: string) {
      this.magicLinkEmail = value;
    },
    setShowCreatePasswordDialog(value: boolean) {
      this.showCreatePasswordDialog = value;
    },
    setCreatePasswordEmail(value: string) {
      this.createPasswordEmail = value;
    },
    setShowUnlockBenefitsDialog(value: boolean) {
      this.showUnlockBenefitsDialog = value;
    },
    setShowUnlockMoreBenefitsDialog(value: boolean) {
      this.showUnlockMoreBenefitsDialog = value;
    },
  },
  getters: {
    getCurrentWidth(): number {
      return this.currentWidth;
    },
    showMobileLayout(): boolean {
      return this.isMobile || this.currentWidth < 1080;
    },
    getShowCreateAccountDialog(): boolean {
      return this.showCreateAccountDialog;
    },
    getShowMagicLinkSentDialog(): boolean {
      return this.showMagicLinkSentDialog;
    },
    getMagicLinkEmail(): string {
      return this.magicLinkEmail;
    },
    getShowCreatePasswordDialog(): boolean {
      return this.showCreatePasswordDialog;
    },
    getCreatePasswordEmail(): string {
      return this.createPasswordEmail;
    },
    getShowUnlockBenefitsDialog(): boolean {
      return this.showUnlockBenefitsDialog;
    },
    getShowUnlockMoreBenefitsDialog(): boolean {
      return this.showUnlockMoreBenefitsDialog;
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: "flxUi",
        storage: localStorage,
      },
    ],
  },
});
